/**
 * Enthusiast Brands — Quick View Modal
 * Fetches product data via /products/{handle}.js and renders in modal.
 * Add-to-cart via Cart API, then updates cart drawer.
 */
(function () {
  'use strict';

  const modal = document.getElementById('eb-quick-view-modal');
  if (!modal) return;

  const backdrop = modal.querySelector('.eb-qv-backdrop');
  const closeBtn = modal.querySelector('.eb-qv-close');
  const loading = modal.querySelector('.eb-qv-loading');
  const content = modal.querySelector('.eb-qv-content');
  const img = document.getElementById('eb-qv-img');
  const title = document.getElementById('eb-qv-title');
  const priceEl = document.getElementById('eb-qv-price');
  const variantsContainer = document.getElementById('eb-qv-variants');
  const variantIdInput = document.getElementById('eb-qv-variant-id');
  const form = document.getElementById('eb-qv-form');
  const qtyInput = document.getElementById('eb-qv-qty');
  const viewFullLink = document.getElementById('eb-qv-view-full');

  let currentProduct = null;
  let currentVariant = null;

  // --- Open Modal ---
  function open(handle) {
    modal.hidden = false;
    loading.hidden = false;
    content.hidden = true;
    document.body.style.overflow = 'hidden';

    fetch(`/products/${handle}.js`)
      .then((r) => r.json())
      .then((product) => {
        currentProduct = product;
        renderProduct(product);
        loading.hidden = true;
        content.hidden = false;
      })
      .catch((err) => {
        console.error('Quick View: Failed to load product', err);
        close();
      });
  }

  // --- Close Modal ---
  function close() {
    modal.hidden = true;
    document.body.style.overflow = '';
    currentProduct = null;
    currentVariant = null;
  }

  // --- Render Product ---
  function renderProduct(product) {
    // Image
    const featuredImg = product.featured_image || product.images[0];
    if (featuredImg) {
      img.src = typeof featuredImg === 'string' ? featuredImg : featuredImg;
      img.alt = product.title;
    }

    // Title
    title.textContent = product.title;

    // Link
    viewFullLink.href = `/products/${product.handle}`;

    // Variants
    variantsContainer.innerHTML = '';
    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
      // Single variant, no selector needed
      selectVariant(product.variants[0]);
    } else {
      renderVariantSelectors(product);
    }

    // Reset quantity
    qtyInput.value = 1;
  }

  // --- Render Variant Selectors ---
  function renderVariantSelectors(product) {
    product.options.forEach((optionName, index) => {
      const group = document.createElement('div');
      group.className = 'eb-qv-variant-group';

      const label = document.createElement('label');
      label.textContent = optionName;
      label.setAttribute('for', `eb-qv-option-${index}`);

      const select = document.createElement('select');
      select.id = `eb-qv-option-${index}`;
      select.dataset.optionIndex = index;

      const values = [...new Set(product.variants.map((v) => v.options[index]))];
      values.forEach((val) => {
        const opt = document.createElement('option');
        opt.value = val;
        opt.textContent = val;
        select.appendChild(opt);
      });

      select.addEventListener('change', () => updateVariantFromSelectors(product));

      group.appendChild(label);
      group.appendChild(select);
      variantsContainer.appendChild(group);
    });

    // Select first variant
    updateVariantFromSelectors(product);
  }

  // --- Update Variant from Selectors ---
  function updateVariantFromSelectors(product) {
    const selects = variantsContainer.querySelectorAll('select');
    const selectedOptions = Array.from(selects).map((s) => s.value);

    const variant = product.variants.find((v) =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );

    if (variant) {
      selectVariant(variant);
    }
  }

  // --- Select Variant ---
  function selectVariant(variant) {
    currentVariant = variant;
    variantIdInput.value = variant.id;

    // Update price
    const price = (variant.price / 100).toFixed(2);
    const comparePrice = variant.compare_at_price
      ? (variant.compare_at_price / 100).toFixed(2)
      : null;

    if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
      priceEl.innerHTML = `<span style="text-decoration:line-through;color:rgba(var(--color-foreground),0.5);margin-right:0.8rem">$${comparePrice}</span> $${price}`;
    } else {
      priceEl.textContent = `$${price}`;
    }

    // Update image if variant has one
    if (variant.featured_image && variant.featured_image.src) {
      img.src = variant.featured_image.src;
    }

    // Update button state
    const atcBtn = form.querySelector('.eb-qv-atc');
    if (!variant.available) {
      atcBtn.disabled = true;
      atcBtn.querySelector('span').textContent = 'Sold Out';
    } else {
      atcBtn.disabled = false;
      atcBtn.querySelector('span').textContent = 'Add to Cart';
    }
  }

  // --- Add to Cart ---
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!currentVariant || !currentVariant.available) return;

    const atcBtn = form.querySelector('.eb-qv-atc');
    atcBtn.disabled = true;
    atcBtn.querySelector('span').textContent = 'Adding...';

    const body = {
      items: [
        {
          id: currentVariant.id,
          quantity: parseInt(qtyInput.value, 10) || 1,
        },
      ],
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then(() => {
        atcBtn.querySelector('span').textContent = 'Added!';

        // Trigger cart drawer update if available
        if (typeof window.routes !== 'undefined') {
          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach((el) => {
                el.textContent = cart.item_count;
              });
              // Dispatch custom event for Dawn's cart drawer
              document.dispatchEvent(
                new CustomEvent('cart:refresh', { bubbles: true })
              );
            });
        }

        setTimeout(() => {
          close();
        }, 800);
      })
      .catch((err) => {
        console.error('Quick View: Add to cart failed', err);
        atcBtn.querySelector('span').textContent = 'Error - Try Again';
        atcBtn.disabled = false;
      });
  });

  // --- Quantity Controls ---
  modal.querySelectorAll('.eb-qv-qty-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const current = parseInt(qtyInput.value, 10) || 1;
      if (this.dataset.action === 'increase') {
        qtyInput.value = Math.min(current + 1, 99);
      } else {
        qtyInput.value = Math.max(current - 1, 1);
      }
    });
  });

  // --- Close Events ---
  backdrop.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  // --- Event Delegation for Quick View Buttons ---
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-quick-view]');
    if (btn) {
      e.preventDefault();
      open(btn.dataset.quickView);
    }
  });

  // Expose for external use
  window.ebQuickView = { open, close };
})();
